import { getDefaultStatisticItem, getTeamLabelByNumber } from '../../utils/utils'

export default {
  statisticScheme: {
    'PT1': getDefaultStatisticItem('statistic.basketball.pt1'),
    'PT2': getDefaultStatisticItem('statistic.basketball.pt2'),
    'PT3': getDefaultStatisticItem('statistic.basketball.pt3'),
    'FOUL': getDefaultStatisticItem('statistic.foul'),
    'TIMEOUT': getDefaultStatisticItem('statistic.timeout')
  },
  statisticEvents: {
    'PT1': 'PT1',
    'PT2': 'PT2',
    'PT3': 'PT3',
    'TIMEOUT': 'TIMEOUT'
  },
  statisticFunction (event, relatedEvent) {
    const eventForProcess = event.EventCode === 'CANCEL' ? relatedEvent : event

    const { EventCode } = eventForProcess

    if (!['FOUL', 'FOUL_D', 'FOUL_U', 'TECHNICAL_FOUL'].includes(EventCode)) return

    const {
      getCurrentPeriod
    } = this
    const { GamePeriod, TeamNumber } = eventForProcess
    const baseProperties = {
      statisticType: 'defaultStatistic',
      property: 'FOUL',
      period: GamePeriod || getCurrentPeriod,
      team: getTeamLabelByNumber(TeamNumber),
      type: event.EventCode === 'CANCEL' ? 'decrement' : 'increment'
    }

    switch (EventCode) {
      case 'TECHNICAL_FOUL':
      case 'FOUL':
        this.updateStatistic(baseProperties)

        return

      case 'FOUL_D':
      case 'FOUL_U':
        this.updateStatistic({
          ...baseProperties,
          ...{
            value: 2
          }
        })
    }
  },
  statisticOrder: [
    'PT1',
    'PT2',
    'PT3',
    'FOUL',
    'TIMEOUT'
  ],
  additionalStatisticBlocks: [
    {
      type: 'shootout',
      component: 'shootout-statistic'
    }
  ]
}
